import React, {useState} from 'react'
import {useForm} from 'react-hook-form'
import TextField from '@material-ui/core/TextField'
import styled from 'styled-components'
import Button from '@material-ui/core/Button'
import {
  StreamSettings,
  useStreamSettings,
} from 'organization/Event/Room/Stream/use-stream-settings'
import {useUpdateStreamSettings} from 'organization/Event/Room/Stream/use-stream-settings'
import {Loader} from 'lib/ui/Loader'

export default function StreamForm(props: {onClose: () => void}) {
  const {register, handleSubmit} = useForm()
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const streamSettings = useStreamSettings()
  const updateStreamSettings = useUpdateStreamSettings()

  const onSave = (data: StreamSettings) => {
    setSubmitting(true)
    updateStreamSettings(data)
      .then(() => {
        props.onClose()
      })
      .catch((e) => {
        setError(e.message)
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  if (streamSettings.data?.stream_url === undefined) {
    return (
      <CenteredLoader>
        <Loader />
      </CenteredLoader>
    )
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSave)}>
        <TextField
          name="stream_url"
          label="Stream URL"
          fullWidth
          disabled={submitting}
          defaultValue={streamSettings.data?.stream_url}
          inputProps={{
            ref: register(),
            'aria-label': 'stream URL',
          }}
        />

        <TextField
          name="stream_key"
          label="Stream Key"
          fullWidth
          disabled={submitting}
          defaultValue={streamSettings.data?.stream_key}
          inputProps={{
            ref: register(),
            'aria-label': 'stream Key',
          }}
        />

        <TextField
          name="stream_page_url"
          label="Stream Page URL"
          fullWidth
          disabled={submitting}
          defaultValue={streamSettings.data?.stream_page_url}
          inputProps={{
            ref: register(),
            'aria-label': 'stream page URL',
          }}
        />

        <div>
          <Error>{error}</Error>
          <br />
          <SaveButton
            variant="contained"
            color="primary"
            fullWidth
            disabled={submitting}
            type="submit"
            aria-label="save custom rtmp stream settings"
          >
            Save Custom RTMP stream settings
          </SaveButton>
        </div>
      </form>
    </>
  )
}

function Error(props: {children: string | null}) {
  if (!props.children) {
    return null
  }

  return <ErrorText>{props.children}</ErrorText>
}

const ErrorText = styled.div`
  margin-top: ${(props) => props.theme.spacing[4]};
  color: ${(props) => props.theme.colors.error};
`

const SaveButton = styled(Button)`
  margin-bottom: ${(props) => props.theme.spacing[4]}!important;
`

const CenteredLoader = styled.div`
  display: flex;
  justify-content: center;
  padding: ${(props) => props.theme.spacing[4]}px;
`
